import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import moduleAudioPlayer from './audio-player/moduleAudioPlayer';
import getters from './getters';
import moduleHelp from './help/moduleHelp';
import moduleLeads from './leads/moduleLeads';
import mutations from './mutations';
import state from './state';

Vue.use(Vuex);

export default new Vuex.Store({
    actions,
    getters,
    modules: {
        audioPlayer: moduleAudioPlayer,
        help:        moduleHelp,
        leads:       moduleLeads,
    },
    mutations,
    state,
    strict: import.meta.env.DEV,
});
